import { render, staticRenderFns } from "./selectGroupControlType.vue?vue&type=template&id=68807637&"
import script from "./selectGroupControlType.vue?vue&type=script&lang=js&"
export * from "./selectGroupControlType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports